export function round(number, places) {
    return +(Math.round(number + "e+" + places)  + "e-" + places);
}

export function net(gross) {
    return round(gross/ 1.23, 2);
}

export function vat(gross) {
    return round(gross - net(gross), 2);
}
